import { useEffect, useState } from 'react';
import cn from 'classnames';

import stripTags from '@framework/dom/stripTags';

import styles from './styles.module.scss';

interface IProps {
  description: string,
  dataTest: string,
  className?: string,
}

const hasContent = (html: string): boolean => {
  if (!html) {
    return false;
  }

  const hasText = stripTags(html)?.trim().length > 0;
  const hasImage = /<img\s/i.test(html);

  return hasText || hasImage;
};

export const Description = ({ description, dataTest, className }: IProps) => {
  const [shouldRender, setShouldRender] = useState(!!description);

  useEffect(() => {
    setShouldRender(hasContent(description));
  }, [description]);

  return (shouldRender ? (
    <div
      className={ cn(styles.description, className) }
      data-test={ dataTest }
    >
      <div dangerouslySetInnerHTML={ { __html: description } } />
    </div>
  ) : null);
};
